import { isIPhone } from "@/common/js/constant";

const loadModule = () => {
    return window.Fusion && window.Fusion.loadModule("SofiBridgeModule");
}

export const checkLogin = (): Promise<boolean> => {
    return new Promise((resolve) => {
        try {
            const module = loadModule();
            if (module && module.sfCheckLogin) {
                module.sfCheckLogin((res: any) => {
                    resolve(res?.logged === 1);
                });
            } else {
                resolve(false);
            }
        } catch (e) {
            resolve(false);
        }
    });
}

// 登录乘客端
export const loginRider = (): Promise<boolean> => {
    return new Promise((resolve) => {
        try {
            const bridge = loadModule();
            bridge?.sfHostRequestLogin((res: {logged : number}) => {
                if (Number(res.logged) === 1) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        } catch (e) {
            resolve(false);
        }
    });
}

export const requestLogin = (): Promise<void> => {
    return new Promise((resolve) => {
        try {
            const module = loadModule();
            if (module && module.sfRequestLogin) {
                module.sfRequestLogin(() => {
                    resolve();
                });
            } else {
                resolve();
            }
        } catch (e) {
            resolve();
        }
    });
}

export const getSofipoTicket = (): Promise<string> => {
    return new Promise((resolve) => {
        try {
            const module = loadModule();
            if (module && module.sfGetSofipoTicket) {
                module.sfGetSofipoTicket({}, (res: string) => {
                    resolve(res);
                });
            } else {
                resolve("");
            }
        } catch (e) {
            resolve("");
        }
    });
}

export const shareWhatsApp = (data: any): Promise<number> => {
    // 分享参数
    const params: any = {
        share_url: data.share_url,
        share_image_url: data.share_img_url || '',
    }
    if (isIPhone) {
        params.share_title = data.share_content || '';
    } else {
        params.share_content = data.share_content || '';
    }
    return new Promise((resolve) => {
        try {
            if (window.Fusion && window.Fusion.shareWhatsApp) {
                // 分享成功返回0，失败返回1, 取消分享返回2
                window.Fusion.shareWhatsApp(params, (res: { share_result: number }) => {
                    resolve(res?.share_result);
                });
            } else {
                resolve(1);
            }   
        } catch (e) {
            resolve(1);
        }
    });
}

export const shareSystem = (data: any): Promise<any> => {
    return new Promise((resolve) => {
        try {
            const module = loadModule();
            if (module && module.sfSharedChannel) {
                module.sfSharedChannel(data, (res: any) => {
                    resolve(res);
                });
            } else {
                resolve(false);
            }
        } catch (e) {
            resolve(false);
        }
    });
}
